export default "/assets/images/problem-solved-02.ffa419f26dddde8a.png";